export default class TarifEcommerceImport extends HTMLAnchorElement {

    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
    }

    events() {
        toastr.options = {
            positionClass: 'toast-top-center'
        };

        if(localStorage.getItem("status")){
            toastr.success('Fichier importé !');
            localStorage.clear();
        }

        var $this = this;
        this.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            var ajaxCall = {
                success: function (data) {
                    if(data.hasOwnProperty('errors')){
                        if(data.errors.length > 0){
                            toastr.error(data.errors);
                        }else{
                            toastr.success('Fichier importé !');
                            window.location.reload();
                        }
                    }
                },
                error: function (data) {
                    toastr.error('Une erreur s\'est produite');
                }
            };

            window.HegydCore.initRemoteModal(
                '#modal',
                this.href,
                function(){
                    $('#submitFormImport').on('submit', function(e){
                        e.preventDefault();

                        var loader = $('#modal').find('.loading');

                        if($('input[name="file-to-import"]')[0].files.length > 0) {
                            let formData = new FormData();
                            formData.append('file-to-import', $('input[name="file-to-import"]')[0].files[0]);

                            swal({
                                title: '',
                                html: "<span>Souhaitez-vous mettre à jour les tarifs de livraison ?</span>",
                                allowOutsideClick: false,
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#ee0000',
                                cancelButtonText: 'Non',
                                confirmButtonText: 'Oui',
                                showLoaderOnConfirm: true,
                                preConfirm: function () {
                                    //On affiche le loader + cache modals
                                    loader.removeClass('hide');
                                    $('#submitFormImport').addClass('hide');

                                    //On envoie les données
                                    $.ajax({
                                        url: document.getElementById("submitFormImport").action,
                                        method: 'POST',
                                        data: formData,
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        success: function (data) {
                                            if (data.hasOwnProperty('errors')) {
                                                if (data.errors.length > 0) {
                                                    toastr.error(data.errors);
                                                } else {
                                                    localStorage.setItem("status",1)
                                                    window.location.href = window.location.pathname;
                                                }
                                            }
                                        },
                                        error: function (data) {
                                            loader.addClass('hide');
                                            swal.close();
                                            toastr.error('Une erreur s\'est produite');
                                        }
                                    });
                                }
                            }).then(function () {
                                swal.close();
                            });
                        }

                    });
                },
                (data) => {
                    if(data.hasOwnProperty('errors')){
                        if(data.errors.length > 0){
                            toastr.error(data.errors);
                        }else{
                            toastr.success('Fichier importé !');
                            window.location.reload();
                        }
                    }
                },
                () => {
                    toastr.error('Une erreur s\'est produite');
                }
            );
        });
    }
}
